import React from 'react'
import Modal from 'blocks.simple/modal/modal'
import FlowDiagram from 'blocks.app/flowDiagram/flowDiagram'
import { cn } from 'ethcss'
import grid from 'blocks.simple/grid/grid.jcss'
import item from 'blocks.simple/item/item.jcss'

const EditorDiagrams = (p_: {open: boolean, onClose: () => {}, pages: object}) => {
    return (
        <Modal open={p_.open} closeIconSize={24} closeIconColor={'white'} mod={'clear'} onClose={p_.onClose}>
            <div className={cn(grid.full, item.previewOpacity)}>
                <FlowDiagram pages={p_.pages} />
            </div>
        </Modal>
    )
}

export default EditorDiagrams
